import React from "react";
import CircularProgress from "@mui/material/CircularProgress";

function Loader(props) {
  const { orange, className, size } = props;
  return (
    <CircularProgress
      id="notificationsIcon"
      className={className}
      size={size}
      sx={{ color: orange ? "var(--main-color)" : "inherit" }}
    />
  );
}
Loader.defaultProps = {
  orange: true,
  className: "",
  size: 20,
};
export default Loader;
